import { Box, styled, Tab, Tabs } from "@mui/material";

import colors from "../../../styles/colors/colors";
import fontWeight from "../../../styles/mui/fontWeight";

export const PatientHeaderTabs = styled(Tabs)((props) => ({
    overflow: "visible",
    "& .MuiTabs-scroller": {
        overflow: "visible",
    },
    marginLeft: "2rem",
    "& .MuiTabs-indicator": {
        backgroundColor: "unset",
    },
    "& .MuiTab-root": {
        whiteSpace: "nowrap",
        width: "auto",
        padding: "0.3rem 2rem 0.2rem 2rem",
    },
    "& .Mui-selected": {
        border: `1px solid ${colors.borders[1]}`,
        color: colors.fonts[18],
        fontSize: ".75rem",
        fontWeight: fontWeight.Weight[6],
        opacity: 1,
        textTransform: "uppercase",
        borderBottom: `1px solid ${props.theme.palette.common.white}`,
    },
    "& .MuiTabs-flexContainer": {
        paddingTop: "20px",
    },
}));

export const PatientHeaderTab = styled(Tab)((props) => ({
  backgroundColor: props.theme.palette.common.white,
  marginRight: "1rem",
  borderRadius: "10px",
  borderBottomRightRadius: "0px",
  borderBottomLeftRadius: "0px",
  border: `1px solid ${colors.borders[1]}`,
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  textTransform: "uppercase",
  overflow: "visible",
  color: colors.fonts[19],
  padding: "0.7rem 0.5rem 0.2rem 0.5rem",
  minHeight: "2.45rem",
  fontSize: ".75rem",
  fontWeight: fontWeight.Weight[3],
  opacity: 0.9,
  width: "10.3rem",
}));

export const patientNameContainer = () => ({
  flex: "0 0 9.5rem",
  maxWidth: "9.5rem",
  minWidth: "9.5rem",
  display: "flex",
  alignItems: "flex-start",
  pr: "0.25rem",
});

export const styles = {
  container: {
    display: "flex",
    width: "100%",
    minWidth: 0,
    padding: "0.2rem 0.2rem 0 0.5rem",
  } as const,
  lineItem: {
    width: "100%",
    minWidth: 0,
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  } as const,
};

export const patientNameTypo = () => ({
  paddingTop: "0.6rem",
  width: "100%",
  minWidth: 0,
  display: "block",
  lineHeight: "1.8rem",
});

export const TabsPanelSectionBox = styled(Box)((props) => ({
  boxShadow: `1px 1px 8px ${colors.dropShadow[4]}`,
  backgroundColor: props.theme.palette.common.white,
  borderRadius: "10px",
  marginBottom: "1rem",
}));

export const PanelBox = styled(Box)(() => ({
  padding: "1.2rem 1.5rem 1rem 1.5rem",
}));

export const BackBtn = () => ({
  width: "4rem",
});

export const HeaderText = () => ({
  paddingLeft: "1rem",
  paddingRight: "1.7rem",
});
export const BCBSMemberStyle = (isBCBS?: boolean) => ({
  border: isBCBS ? `3px solid ${colors.borders[9]}` : "",
  borderRadius: isBCBS ? "10px" : "",
});
export const MemberInfoContainer = () => ({
  display: "flex",
  columnGap: "0.75rem",
  paddingBottom: "1rem",
  justifyContent: "space-between",
});

export const MemberInfoField = () => ({
  padding: "0.9rem 1rem 0rem 0.5rem",
});

export const AccommodationMemberInfoField = () => ({
  flex: "0 0 18rem",
  width: "18rem",
  minWidth: "18rem",
  maxWidth: "18rem",
});

export const AddressMemberInfoField = () => ({
  padding: "0.9rem 0.5rem 0rem 0rem",
});

export const ItemIconBox = () => ({
  color: colors.fonts[18],
  paddingRight: "0.4rem",
  paddingTop: "0.8rem",
});

export const PatientDetailsValue = () => ({
  paddingTop: "0.8rem",
  lineHeight: "1.2rem",
});

export const LowerContainer = () => ({
  padding: "0.5rem 0rem",
  display: "flex",
  columnGap: "0.75rem",
});

export const AddressField = () => ({
  margin: "0rem 1rem",
});

export const FieldValue = () => ({
  paddingTop: "0.5rem",
  lineHeight: "1.2rem",
  wordBreak: "break-word",
});
